import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChangesItemContainer } from './styled';

interface ChangesItemProps {
  title: string;
  items: { deviceId: string; deviceName: string }[];
}

const ChangesItem = ({ title, items }: ChangesItemProps) => {
  const { t } = useTranslation();

  return (
    !!items?.length && (
      <ChangesItemContainer>
        <div className="changes-item-title">{t(title)}</div>
        {items?.map(item => (
          <div key={item?.deviceId}>{item?.deviceName}</div>
        ))}
      </ChangesItemContainer>
    )
  );
};

export default ChangesItem;
